/**
 * For VistorType sub groups we want to ensure these continue to be considered as step after selecting a value.
 * If not it will skip a step
 * @param steps
 */
const decorateFieldWithShowForVisitorType = (
  steps: any,
  formState: any,
  data: any
) => {
  const currentVT = formState
    ? formState.visitortype || formState.visitortype_groups
    : data.currentVisitorType;
  return steps.map((step: any) => {
    const fields = step.fields.map((field: any) => {
      if (!field.showBoolean && field.fieldId === 'visitortype') {
        const hasVT = field.list.findIndex((el: any) => {
          return el.value === formState.visitortype_groups || currentVT;
        });
        return {
          ...field,
          showBoolean: hasVT >= 0,
        };
      }
      return field;
    });
    return Object.assign(step, { fields });
  });
};
export default decorateFieldWithShowForVisitorType;
try {
    // @ts-ignore
    decorateFieldWithShowForVisitorType.displayName = "decorateFieldWithShowForVisitorType";
    // @ts-ignore
    decorateFieldWithShowForVisitorType.__docgenInfo = { "description": "For VistorType sub groups we want to ensure these continue to be considered as step after selecting a value.\nIf not it will skip a step", "displayName": "decorateFieldWithShowForVisitorType", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/containers/stepContainer/dataTransform/decorateFieldWithShowForVisitorType.ts#decorateFieldWithShowForVisitorType"] = { docgenInfo: decorateFieldWithShowForVisitorType.__docgenInfo, name: "decorateFieldWithShowForVisitorType", path: "src/containers/stepContainer/dataTransform/decorateFieldWithShowForVisitorType.ts#decorateFieldWithShowForVisitorType" };
}
catch (__react_docgen_typescript_loader_error) { }